import { render, staticRenderFns } from "./DetailsDeviceCard.vue?vue&type=template&id=04d15462&scoped=true"
import script from "./DetailsDeviceCard.vue?vue&type=script&lang=ts"
export * from "./DetailsDeviceCard.vue?vue&type=script&lang=ts"
import style0 from "./DetailsDeviceCard.vue?vue&type=style&index=0&id=04d15462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d15462",
  null
  
)

export default component.exports